import React, { useState, useEffect } from "react";
import "./ImageCarousel.scss";
import arrow from "../../assets/icons/arrow-black.svg";

const ImageCarousel = ({ content, height }) => {

    const [currentIndex, setCurrentIndex] = useState(0);


    const goToPrev = () => {
        setCurrentIndex((prev) => (prev === 0 ? content.length - 1 : prev - 1));
    };

    const goToNext = () => {
        setCurrentIndex((prev) => (prev === content.length - 1 ? 0 : prev + 1));
    };

    const goToIndex = (index) => {
        setCurrentIndex(index);
    };
    useEffect(() => {
        if (content.length > 1) {
            const timer = setInterval(() => {
                goToNext();
            }, 5000);

            return () => clearInterval(timer);
        }
    }, [currentIndex]);
    return (
        <div className="VirasatV2custom-carousel">

            <div
                className="VirasatV2custom-carousel-track"
                style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
                {content.map((contnt, i) => (
                    <div className="VirasatV2custom-carousel-slide" key={i}
                        style={{ backgroundImage: `url(${contnt.src})`, height }}>
                        <div className="VirasatV2custom-carousel-slide-inner" />
                    </div>
                ))}
            </div>
            {content.length > 1 && <div className="VirasatV2custom-carousel-button left" onClick={goToPrev}>
                <img alt="" src={arrow} />
            </div>}
            {content.length > 1 && <div className="VirasatV2custom-carousel-button right" onClick={goToNext}>
                <img alt="" src={arrow} />
            </div>}

            {content.length > 1 && <div className="VirasatV2custom-carousel-dots">
                {content.map((_, i) => (
                    <div
                        key={i}
                        onClick={() => goToIndex(i)}
                        className={`dot-cs ${i === currentIndex ? "active" : ""}`}
                    />
                ))}
            </div>}
        </div>
    );
};

export default ImageCarousel;
